// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"347b8fd4","498":"db2d5e66","703":"5a2476ca"}[chunkId] + ".chunk.js";
};